import { apiGetReviews, apiRequestRemoval } from 'app/api/agency-reviews/agency-reviews';
import { ApiNS } from 'app/api/api';
import axios from 'axios';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppNS } from '../';
import { AppThunk } from './index';

export interface AgencyReviewsState {
  page: number;
  perPage: number;
  search: string;
  totalEntries: number;
  items: Array<AppNS.Review>;
  isLoaded: boolean;
  isLoading: boolean;
  isFavRemoving: boolean;
  isFavRemovingError: boolean;
}

const initialState: AgencyReviewsState = {
  page: 1,
  perPage: 10,
  search: '',
  totalEntries: 0,
  items: [],
  isLoaded: false,
  isLoading: false,
  isFavRemoving: false,
  isFavRemovingError: false,
};

const agencyReviews = createSlice({
  name: 'agencyReviews',
  initialState,
  reducers: {
    resetCollection(state) {
      state.items = [];
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setCurrentParams(state, action: PayloadAction<AppNS.Params>) {
      state.page = action.payload.page;
      state.search = action.payload.search;
    },
    getReviewsStart(state: AgencyReviewsState) {
      state.isLoading = true;
    },
    getReviewsSuccess(state: AgencyReviewsState, action: PayloadAction<ApiNS.ReviewsListResponse>) {
      // state.error = null;
      state.isLoading = false;
      state.items = action.payload.results;
      state.totalEntries = action.payload.totalEntries;
    },
    getReviewsFailed(state: AgencyReviewsState) {
      state.items = [];
      // state.error = action.payload;
      state.isLoading = false;
    },
    requestRemovalStart(state: AgencyReviewsState) {
      state.isLoading = true;
    },
    requestRemovalSuccess(state: AgencyReviewsState, action: PayloadAction<AppNS.Params>) {
      const newItems = state.items.map((item) => {
        return item.id === action.payload.model.id
          ? {
              ...item,
              removalRequestAt: action.payload.model.properties.removalRequestAt,
              removalRequestState: action.payload.model.properties.removalRequestState,
              removalRequestReason: action.payload.model.properties.removalRequestReason,
            }
          : item;
      });
      state.items = newItems;
      state.isLoading = false;
    },
    requestRemovalFailed(state: AgencyReviewsState) {
      state.isLoading = false;
    },
  },
});

export const {
  getReviewsStart,
  getReviewsSuccess,
  getReviewsFailed,
  setCurrentParams,
  requestRemovalStart,
  requestRemovalSuccess,
  requestRemovalFailed,
} = agencyReviews.actions;

export default agencyReviews.reducer;

export const getReviews =
  (searchQuery: string, page: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getReviewsStart());
      const result = await apiGetReviews(searchQuery, page);
      dispatch(getReviewsSuccess(result));
    } catch (err: any) {
      if (err instanceof axios.Cancel) {
        // when request is cancelled there is no need to throw error.
        return;
      }
      console.error(err.toString());
      dispatch(getReviewsFailed());
    }
  };

export const requestRemoval =
  (reqData: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(requestRemovalStart());
      const response = await apiRequestRemoval(reqData);
      dispatch(requestRemovalSuccess(response));
    } catch (err: any) {
      if (err instanceof axios.Cancel) {
        // when request is cancelled there is no need to throw error.
        return;
      }
      dispatch(requestRemovalFailed());
    }
  };
